// extracted by mini-css-extract-plugin
export default {"txt":"NotFound_txt__UR0md"};